import { db, app } from '../firebase'
import Firebase from 'firebase'

export default ({ namesDb } = {}) => {
  const addRating = (nameKey, user, rating) => {
    return namesDb.child(nameKey).child('rating').child(user).set(rating)
  }

  const removeRating = (nameKey, user) => {
    return namesDb.child(nameKey).child('rating').child(user).remove()
  }
  const addComment = (nameKey, user, comment) => {
    const obj = {
      comment,
      user,
      dateTime: Firebase.database.ServerValue.TIMESTAMP,
    }
    return db().ref('comment').child(nameKey).push(obj)
    .then(() => {
      return namesDb.child(nameKey).child('totalComment')
      .transaction((currentCount) => currentCount + 1)
    })
  }
  const addName = (recommendation, user) => {
    const obj = {
      value: recommendation,
      recommended: user,
      rating: {},
    }
    const recommendationNormalized = recommendation.toLowerCase()
    return namesDb.child(recommendationNormalized).once('value')
    .then(snapshot => {
      if (snapshot.exists()) {
        return Promise.reject('Name exists')
      }
      return namesDb.child(recommendationNormalized).set(obj)
    })
    // const key = namesDb.push().key
  }

  const removeName = (nameKey, user) => {
    // Simple ACL
    namesDb.child(nameKey).once('value')
    .then((snapshot) => {
      const name = snapshot.val()
      if (name.recommended === user) {
        return namesDb.child(nameKey).remove()
      }
      return Promise.reject('no ACL')
    })
    .catch(() => Promise.reject('Error'))
  }

  return {
    addRating,
    removeRating,
    addName,
    removeName,
    addComment,
  }
}



// WEBPACK FOOTER //
// ./src/models/names.js